import {Box} from "@variocube/app-api";
import {Fragment, ReactElement} from "react";
import {Avatar, Badge, MaterialIcon} from "@variocube/cube-ui";
import {blue, green, lightBlue, red} from "@mui/material/colors";
import * as React from "react";
import {Chip, Stack} from "@mui/material";

export function BoxProperties({box}: { box: Box }) {
    return (
        <Stack spacing={0.5} direction="row" alignItems="center">
            {box.types.indexOf("Master") >= 0 ? (
                <Badge>Master</Badge>
            ) : (
                <Fragment>
                    {box.types.map((t) => <Avatar key={t}><span>{t}</span></Avatar>)}
                    <BoxFeatures box={box} />
                </Fragment>
            )}
        </Stack>
    )
}

function BoxFeatures({box}: { box: Box }){
    return(
        <Fragment>
            {box.accessible &&
                <FeatureChip Icon={MaterialIcon.accessible} color={blue["700"]} />
            }
            {box.cooled &&
                <FeatureChip Icon={MaterialIcon.ac_unit} color={lightBlue["400"]} />
            }
            {box.dangerousGoods &&
                <FeatureChip Icon={MaterialIcon.warningAmber} color={red["400"]} />
            }
            {box.charger &&
                <FeatureChip Icon={MaterialIcon.batteryChargingFull} color={green["500"]} />
            }
        </Fragment>
    );
}

interface FeatureChipProps{
    color: string;
    Icon: ReactElement;
}

function FeatureChip({color, Icon}: FeatureChipProps){
    return(
        <Fragment>
            <Chip sx={{
                borderColor: color,
                color,
                "&.MuiChip-root .MuiChip-icon": {
                    color,
                },
                "&.MuiChip-root .MuiChip-label": {
                    paddingLeft: 0
                },
                width: "2.5em",
                height: "2.5em"
            }}
                  variant="outlined"
                  icon={Icon}
            />
        </Fragment>
    );
}